import React from 'react';
import { Button, Icon, Table, Divider } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import PermissionsManager from '../../PermissionsManager';

const MenuCategoriesTable = ({ color = 'olive', categories = [] }) => {
  return (
    <Table selectable singleLine color={color}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Nom</Table.HeaderCell>
          <Table.HeaderCell>Ordre</Table.HeaderCell>
          <Table.HeaderCell>Nombre de liens</Table.HeaderCell>
          <Table.HeaderCell>Dernière modification</Table.HeaderCell>
          <Table.HeaderCell>Action</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {categories.map((category) => {
          return (
            <Table.Row key={category.id}>
              <Table.Cell>{category.name}</Table.Cell>
              <Table.Cell>{category.order}</Table.Cell>
              <Table.Cell>{category.linksDetails.length}</Table.Cell>
              <Table.Cell>{category.updated_at}</Table.Cell>
              <Table.Cell>
                <Button
                  as={Link}
                  name="category"
                  to={`menu/categories/${category.id}`}
                  icon
                  size="small"
                >
                  <Icon name="pencil" />
                </Button>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>

      <PermissionsManager hasPermissions={['update_menu']}>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="5">
              <Button
                as={Link}
                name="new"
                to="/menu/categories/new"
                floated="right"
                icon
                labelPosition="left"
                color="olive"
                size="small"
              >
                <Icon name="book" /> Ajouter une catégorie
              </Button>
              <Divider hidden={true} />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </PermissionsManager>
    </Table>
  );
};

export default MenuCategoriesTable;



// WEBPACK FOOTER //
// ./src/components/form/menuCategory/MenuCategory.js